import React, { useState, useEffect } from 'react';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import CHGReview from './components/CHGReview';
import Software from './components/Software';
import Infrastructure from './components/Infrastructure';
import ITOpsAdvisor from './components/IncidentAdvisor';
import VendorStatus from './components/VendorStatus';
import ITOpsMetrics from './components/ITOpsMetrics';
import Information from './components/Information';
import Prompts from './components/Prompts';
import Financials from './components/Financials';
import KBUpload from './components/KBUpload';
import KnowledgeBaseDocs from './components/docs/KnowledgeBaseDocs';
import ReviewedCHG from './components/ReviewedCHG';

function App() {
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [theme, setTheme] = useState(() => localStorage.getItem('vision-theme') || 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('vision-theme', theme);
  }, [theme]);

  return (
    <div className="flex h-screen relative overflow-hidden bg-bg text-text-primary">
      <Sidebar currentPage={currentPage} setCurrentPage={setCurrentPage} />
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top bar with theme toggle */}
        <div className="hidden lg:flex items-center justify-end px-6 py-2 border-b border-border bg-surface">
          <div className="flex items-center bg-surface-2 rounded-full p-0.5 border border-border">
            <button
              onClick={() => setTheme('light')}
              className={`p-1.5 rounded-full transition-colors ${theme === 'light' ? 'bg-blue-500 text-white' : 'text-text-muted hover:text-text-secondary'}`}
              aria-label="Light mode"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>
            </button>
            <button
              onClick={() => setTheme('dark')}
              className={`p-1.5 rounded-full transition-colors ${theme === 'dark' ? 'bg-blue-500 text-white' : 'text-text-muted hover:text-text-secondary'}`}
              aria-label="Dark mode"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>
            </button>
          </div>
        </div>
        <main className="flex-1 overflow-y-auto pt-16 lg:pt-0 bg-bg">
          {currentPage === 'dashboard' ? <Dashboard /> : currentPage === 'software' ? <Software /> : currentPage === 'infrastructure' ? <Infrastructure /> : currentPage === 'incidentadvisor' ? <ITOpsAdvisor /> : currentPage === 'vendorstatus' ? <VendorStatus /> : currentPage === 'itopsmetrics' ? <ITOpsMetrics /> : currentPage === 'information' ? <Information /> : currentPage === 'prompts' ? <Prompts /> : currentPage === 'financials' ? <Financials /> : currentPage === 'kbupload' ? <KBUpload /> : currentPage === 'kbdocs' ? <KnowledgeBaseDocs /> : currentPage === 'reviewedchg' ? <ReviewedCHG /> : <CHGReview />}
        </main>
      </div>
    </div>
  );
}

export default App;
